import { ReactNode } from "react";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import Footer from "../Footer";
import InformeWelcome from "./InformeWelcome";

interface Props {
    children: ReactNode;
    title?: string | null
    subTitle?: string | null
}

export default function HomeLayout({ children, title, subTitle }: Props) {

    const { contrastMode } = useAccessibility();

    return (
        <div className={contrastMode ? 'container-login' : 'container-login img-background-login'}>
            <div className='container-login-painel'>
                <InformeWelcome />
                <div className='width-100 login-container-end'>{children}</div>
            </div>
            <Footer />
        </div>

    )
}
